import _0 from './0';
import _1 from './1';
import _15 from './1.5';
import _2 from './2';
import _25 from './2.5';
import _3 from './3';
import _35 from './3.5';
import _4 from './4';
import _45 from './4.5';
import _5 from './5';

export default {
  '0.0': _0,
  '1.0': _1,
  '1.5': _15,
  '2.0': _2,
  '2.5': _25,
  '3.0': _3,
  '3.5': _35,
  '4.0': _4,
  '4.5': _45,
  '5.0': _5,
} as Record<string, (props: { className?: string }) => JSX.Element>;
